import React, { Component } from 'react'
import PropTypes from 'prop-types'

import FormNew from './FormNew'
import FormOld from './FormOld'

class Form extends Component {
  static contextTypes = {
    getFlags: PropTypes.func,
  }

  render() {
    const { getFlags } = this.context
    const flags = getFlags?.() || {}
    const useNew = flags.hasOnSubmitInputAction === true

    if (useNew) {
      return <FormNew {...this.props} />
    }

    return <FormOld {...this.props} />
  }
}

export default Form
